import { LoadPatientSchedules } from 'domain/usecases/patient/load-patient-schedules'
import { PatientRepository } from 'repository/interfaces/patient-repository'
import { Interval, Pagination } from 'service/protocols/api/api-client'

export class RemoteLoadPatientSchedules implements LoadPatientSchedules {
  private readonly patientRepository: PatientRepository

  constructor(patientRepository: PatientRepository) {
    this.patientRepository = patientRepository
  }

  load(
    params?: LoadPatientSchedules.Params,
    pagination?: Pagination,
    interval?: Interval
  ): Promise<LoadPatientSchedules.Model[]> {
    return this.patientRepository.loadPatientSchedules(
      params,
      pagination,
      interval
    )
  }
}

export type LoadPatientSchedulesModel = LoadPatientSchedules.Model
